(function ($, angular, window) {
    'use strict';

    window.THF.Angular.JoinForm.directive('thfFieldSelectMonthYear', ['thfFieldHelper','$timeout','$sce', function(thfFieldHelper, $timeout, $sce) {
        var link = function (scope, el) {
            scope.isValid = thfFieldHelper.isValid;
            scope.labelIdentifier = thfFieldHelper.formLabelIdentifier();
            scope.tooltip = $sce.trustAsHtml((typeof scope.field.tooltip !== 'undefined') ? scope.field.tooltip : '');

            var now = new Date();
            var currentMonth = (now.getMonth() + 1);
            var currentYear = now.getFullYear();
            var maxYear = now.getFullYear() + 7;

            scope.fieldValue = {
                month: formatMonth(currentMonth),
                year: currentYear.toString()
            };
            scope.months = [];
            scope.years = [];

            /**
             * Scopped callbacks
             */
            scope.updateModel = updateModel;

            updateFromModel();
            updateModel();

            function updateModel() {
                populateMonthDropdown();
                populateYearDropdown();
                scope.model[scope.field.name] = scope.fieldValue.month + '/' + scope.fieldValue.year;
            }

            function updateFromModel() {
                if (
                    typeof scope.model[scope.field.name] !== 'undefined'
                    && /^[0-9]{2}\/[0-9]{4}$/.test(scope.model[scope.field.name])
                ) {
                    var splitValue = scope.model[scope.field.name].split('/');
                    if (splitValue.length === 2) {
                        scope.fieldValue.month = splitValue[0];
                        scope.fieldValue.year = splitValue[1];
                    }
                }
            }

            function populateMonthDropdown() {
                scope.months = [];

                var month, monthStart;
                if (scope.fieldValue.year == currentYear) {
                    monthStart = currentMonth;
                }
                else {
                    monthStart = 1;
                }

                for (month = monthStart; month <= 12; month++) {
                    scope.months.push({
                        label: formatMonth(month),
                        value: formatMonth(month)
                    });
                }

                if (parseInt(scope.fieldValue.month, 10) < monthStart) {
                    scope.fieldValue.month = formatMonth(monthStart);
                }
            }

            function populateYearDropdown() {
                scope.years = [];
                var year;
                for (year = currentYear; year < maxYear; year++) {
                    scope.years.push({
                        label: year,
                        value: year
                    });
                }
            }


            function formatMonth(month) {
                return (month < 10) ? '0' + month : month.toString();
            }

            $('select', el).selectpicker({
                noneSelectedText: "Please select", template: {
                    caret: '<span class="caret">' +
                    '<svg class="icon icon-closed" viewBox="'+scope.formState.icon.up.viewBox+'"><use xlink:href="'+scope.formState.icon.up.src+'"></use></svg>' +
                    '<svg class="icon icon-open" viewBox="'+scope.formState.icon.down.viewBox+'"><use xlink:href="' + scope.formState.icon.down.src+ '"></use></svg>' +
                    '</span>'
                }
            });

            scope.$watchGroup([
                'model.'+scope.field.name
            ], function() {
                $timeout(function() {
                    $('select', el).selectpicker('refresh');
                });
            });
        };
        return {
            'restrict': 'E',
            'replace': true,
            'scope': {
                'formState': '=',
                'formField': '=',
                'formModel': '=',
                'field': '=',
                'validation': '=',
                'model': '=',
                'fieldActions': '=',
                'validationRules': '='
            },
            'link': link,
            'templateUrl': function() {
                return THF.Utility.Location.cacheBustUrl('/static/views/join-form/fields/selectMonthYear.html');
            }
        };
    }]);
})(jQuery, angular, window);
